const getErrorMessage = (err, fallback) =>
  err?.response?.data?.['hydra:description'] ||
  err.message ||
  fallback ||
  'something went wrong'

export default getErrorMessage
